var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "#FF5F50",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 45C28.0302 45 26.0796 44.612 24.2597 43.8582C22.4399 43.1044 20.7863 41.9995 19.3934 40.6066C18.0005 39.2137 16.8956 37.5601 16.1418 35.7402C15.388 33.9204 15 31.9698 15 30C15 28.0302 15.388 26.0796 16.1418 24.2597C16.8956 22.4399 18.0005 20.7863 19.3934 19.3934C20.7863 18.0005 22.4399 16.8956 24.2597 16.1418C26.0796 15.388 28.0302 15 30 15L30 30L30 45Z",
    fill: "#FF5F50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C31.9698 15 33.9204 15.388 35.7403 16.1418C37.5601 16.8956 39.2137 18.0005 40.6066 19.3934C41.9995 20.7863 43.1044 22.4399 43.8582 24.2597C44.612 26.0796 45 28.0302 45 30C45 31.9698 44.612 33.9204 43.8582 35.7403C43.1044 37.5601 41.9995 39.2137 40.6066 40.6066C39.2137 41.9995 37.5601 43.1044 35.7403 43.8582C33.9204 44.612 31.9698 45 30 45L30 30L30 15Z",
    fill: "#FF5F50",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/basic.04ba9a95.svg";
export { ForwardRef as ReactComponent };